import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type OptimizedAlphaReturnsWeightsCovariancesPreviewProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;
  fullScreen: boolean;
  context?: ts.types.signal.SignalAnalysisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'optimized_alpha_model_data' | 'optimized_alpha_model_covariance', string>;

  title: string;
};

const OptimizedAlphaReturnsWeightsCovariancesPreview = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  fullScreen,
  widgetPaths,
  mode,
  params,
  setParams,
  context,
  title,
}: OptimizedAlphaReturnsWeightsCovariancesPreviewProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        readOnly={readOnly}
        widgetKey={widgetKey}
        fullScreen={fullScreen}
        loadWidgetData={loadWidgetData}
        definition={
          (context.definition as ts.types.signal.AlphaDefinition)?.json_definition as ts.types.signal.OptimizedModel
        }
        optimizedAlphaData={widgetPaths['optimized_alpha_model_data']}
        optimizedCovariance={widgetPaths['optimized_alpha_model_covariance']}
        title={title}
      />
    </>
  );

  return (
    <>{mode == 'edit' ? <Form params={params} setParams={setParams} context={context} /> : renderJobComponent()}</>
  );
};

export default OptimizedAlphaReturnsWeightsCovariancesPreview;
